import { _Logger } from "../../../../services/core";
function ChangeView(_ref) {
  var map = _ref.map,
    center = _ref.center,
    zoom = _ref.zoom;
  _Logger.info('Change view', '', {
    map: map
  });
  if (map.setCenter) {
    map.setCenter(center, zoom);
  } else if (map.setView) {
    map.setView(center, zoom);
  }
  return null;
}
export default ChangeView;